<template>
    <footer class="ib-footer">
        <div class="ibf-container">
            <div class="ibf-grid">
                <!-- Rangée 1 : badges/branding alignés sur les colonnes -->
                <div class="ibf-logo-wrap">
                    <img
                        class="ibf-logo"
                        src="https://imprimbook.fr/wp-content/uploads/2025/09/IMPRIMBOOK-logo_blanc_Plan-de-travail-1-768x201.png"
                        width="400"
                        height="105"
                        alt="imprimbook.fr"
                    >
                </div>

                <div class="ibf-badge ibf-badge-fr" aria-label="Fabrication française">
                    <img
                        src="https://imprimbook.fr/wp-content/uploads/2025/09/logo-made-in-france-300x138.png"
                        alt="Fabrication française"
                    >
                </div>

                <div class="ibf-badge ibf-badge-vert" aria-label="Imprim'Vert">
                    <img
                        src="https://imprimbook.fr/wp-content/uploads/2025/09/logo_eco-responsible-printing-300x179.png"
                        alt="Imprim'Vert"
                    >
                </div>

                <!-- Rangée 2 : contenu des 3 colonnes -->
                <div class="ibf-col ibf-about">
                    <h3>Plateforme 100&nbsp;% dédiée à l’impression de livres en ligne.</h3>
                    <p>
                        Auto-édition, microédition, catalogues, livres, manuels et bien plus.
                        Une filiale du Groupe Santerre, expert français de l'impression.
                    </p>
                </div>

                <nav class="ibf-col ibf-links" aria-label="Liens utiles">
                    <ul>
                        <li><a href="https://www.imprimbook.fr/index.php/preparer-mon-fichier/">PRÉPARER MON FICHIER</a></li>
                        <li><a href="/self-publishing">IMPRIMER MON LIVRE</a></li>
                        <li><a href="/self-publishing/books">MA BIBLIOTHÈQUE</a></li>
                        <li><a href="https://imprimbook.fr/index.php/tout-pour-votre-com/">TOUT POUR MA COM’</a></li>
                        <li><a href="https://imprimbook.fr/index.php/impression-de-livres-ecoresponsable/">ECO FRIENDLY</a></li>
                        <li><a href="https://imprimbook.fr/index.php/contact/">CONTACT</a></li>
                        <li><a href="https://imprimbook.fr/index.php/sample-page/">BLOG</a></li>
                    </ul>
                </nav>

                <div class="ibf-col ibf-social">
                    <h4 class="ibf-social-title">
          <span class="ibf-social-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="7" y1="7" x2="17" y2="17"></line>
              <polyline points="17 7 17 17 7 17"></polyline>
            </svg>
          </span>
                        Suivez-nous
                    </h4>
                    <div class="ibf-icons">
                        <a href="/" aria-label="Facebook" target="_blank" rel="noopener noreferrer" class="social-button"><svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><title>Facebook</title><path d="M31.997 15.999c0-8.836-7.163-15.999-15.999-15.999s-15.999 7.163-15.999 15.999c0 7.985 5.851 14.604 13.499 15.804v-11.18h-4.062v-4.625h4.062v-3.525c0-4.010 2.389-6.225 6.043-6.225 1.75 0 3.581 0.313 3.581 0.313v3.937h-2.017c-1.987 0-2.607 1.233-2.607 2.498v3.001h4.437l-0.709 4.625h-3.728v11.18c7.649-1.2 13.499-7.819 13.499-15.804z"></path></svg></a>
                        <a href="http://www.instagram.com/imprimbook" aria-label="Instagram" target="_blank" rel="noopener noreferrer" class="social-button"><svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>Instagram</title><path d="M7 1c-1.657 0-3.158 0.673-4.243 1.757s-1.757 2.586-1.757 4.243v10c0 1.657 0.673 3.158 1.757 4.243s2.586 1.757 4.243 1.757h10c1.657 0 3.158-0.673 4.243-1.757s1.757-2.586 1.757-4.243v-10c0-1.657-0.673-3.158-1.757-4.243s-2.586-1.757-4.243-1.757zM7 3h10c1.105 0 2.103 0.447 2.828 1.172s1.172 1.723 1.172 2.828v10c0 1.105-0.447 2.103-1.172 2.828s-1.723 1.172-2.828 1.172h-10c-1.105 0-2.103-0.447-2.828-1.172s-1.172-1.723-1.172-2.828v-10c0-1.105 0.447-2.103 1.172-2.828s1.723-1.172 2.828-1.172zM16.989 11.223c-0.15-0.972-0.571-1.857-1.194-2.567-0.754-0.861-1.804-1.465-3.009-1.644-0.464-0.074-0.97-0.077-1.477-0.002-1.366 0.202-2.521 0.941-3.282 1.967s-1.133 2.347-0.93 3.712 0.941 2.521 1.967 3.282 2.347 1.133 3.712 0.93 2.521-0.941 3.282-1.967 1.133-2.347 0.93-3.712zM15.011 11.517c0.122 0.82-0.1 1.609-0.558 2.227s-1.15 1.059-1.969 1.18-1.609-0.1-2.227-0.558-1.059-1.15-1.18-1.969 0.1-1.609 0.558-2.227 1.15-1.059 1.969-1.18c0.313-0.046 0.615-0.042 0.87-0.002 0.74 0.11 1.366 0.47 1.818 0.986 0.375 0.428 0.63 0.963 0.72 1.543zM17.5 7.5c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1 0.448 1 1 1z"></path></svg></a>
                        <a href="http://www.linkedin.com/company/imprimbook" aria-label="Linkedin" target="_blank" rel="noopener noreferrer" class="social-button"><svg fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><title>Linkedin</title><path d="M3.703 22.094h3.609v-10.844h-3.609v10.844zM7.547 7.906c-0.016-1.062-0.781-1.875-2.016-1.875s-2.047 0.812-2.047 1.875c0 1.031 0.781 1.875 2 1.875h0.016c1.266 0 2.047-0.844 2.047-1.875zM16.688 22.094h3.609v-6.219c0-3.328-1.781-4.875-4.156-4.875-1.937 0-2.797 1.078-3.266 1.828h0.031v-1.578h-3.609s0.047 1.016 0 10.844v0h3.609v-6.062c0-0.313 0.016-0.641 0.109-0.875 0.266-0.641 0.859-1.313 1.859-1.313 1.297 0 1.813 0.984 1.813 2.453v5.797zM24 6.5v15c0 2.484-2.016 4.5-4.5 4.5h-15c-2.484 0-4.5-2.016-4.5-4.5v-15c0-2.484 2.016-4.5 4.5-4.5h15c2.484 0 4.5 2.016 4.5 4.5z"></path></svg></a>
                    </div>
                </div>
            </div>

            <div class="ibf-bottom">
                <p>© 2025 imprimbook.fr · Site réalisé par le <a href="https://www.groupesanterre.fr/" target="_blank" rel="noopener">Groupe Santerre</a></p>
                <p class="ibf-legal">
                    <a href="#">Mentions légales</a> ·
                    <a href="#">Politique de confidentialité</a> ·
                    <a href="https://imprimbook.fr/index.php/conditions-generales/">Conditions générales</a>
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from "vuex";
import madeInFrance from "@/assets/img/imprimbook/custom-footer/made-in-france.png";
import ecoResponsiblePrinting from "@/assets/img/imprimbook/custom-footer/eco-responsible-printing.png";
import groupeSanterre from "@/assets/img/imprimbook/custom-footer/groupe_santerre.png";

export default {
    name: "ImprimBookFooter",
    data() {
        return {
            IMGs: { madeInFrance, ecoResponsiblePrinting, groupeSanterre },
        };
    },
    computed: {
        ...mapGetters("config", {
            shop: "shop",
            shopDefaultMail: "shopDefaultMail",
        }),
    },
};
</script>

<style>
:root{
    --ib-blue:#36495c;
    --ib-gold:#dec38f;
    --ib-text:#dbe4ea;
}
</style>

<style lang="scss" scoped>
.ib-footer{
    background: var(--ib-blue, #36495c);
    color: var(--ib-text, #dbe4ea);
    font-family: "Nexa", Arial, sans-serif;
    padding: 36px 0 24px;
}
.ibf-container{ max-width:1200px; margin:0 auto; padding:0 24px; }

/* === Grille 3 colonnes : badges (row 1) + contenu (row 2) alignés === */
.ibf-grid{
    display:grid;
    grid-template-columns: 1.4fr 0.9fr 0.7fr;
    gap: 24px 32px;
    align-items:start;
}
.ibf-logo-wrap{ grid-column:1; grid-row:1; display:flex; align-items:center; }
.ibf-badge-fr{ grid-column:2; grid-row:1; }
.ibf-badge-vert{ grid-column:3; grid-row:1; }
.ibf-about{ grid-column:1; grid-row:2; }
.ibf-links{ grid-column:2; grid-row:2; }
.ibf-social{ grid-column:3; grid-row:2; }

/* === Logo principal === */
.ibf-logo{
    max-width: 405px;
    width: 100%;
    height: auto;
    display:block;
}

/* === Capsules blanches homogènes ===
   - même gabarit pour un alignement propre
   - images centrées, non déformées
   - tailles des logos visés : FR 168x77, Vert 166x100 (on laisse de l’air) */
.ibf-badge{
    --badge-w: 180px;
    --badge-h: 110px;
    width: var(--badge-w);
    height: var(--badge-h);
    background:#fff;
    display:flex; align-items:center; justify-content:center;
}
.ibf-badge img{
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display:block;
}

/* === Colonne Liens (espacement vertical réduit) === */
.ibf-links ul{ list-style:none; margin:0; padding:0; }
.ibf-links li + li{ margin-top: 4px; }        /* rapproché */
.ibf-links a{
    display:block;
    color:#e7eef3;
    text-decoration:none;
    font-weight:700;
    font-size:12px;
    letter-spacing:.02em;
    text-transform:uppercase;
    line-height: 1.2;                           /* compact */
    padding: 4px 0;                              /* compact */
}
.ibf-links a:hover{ color: var(--ib-gold, #dec38f); }

/* === Colonne Social === */
.ibf-social-title{
    color:#fff; font-weight:800; margin:0 0 10px;
    display:flex; align-items:center; gap:8px;
}
.ibf-social-icon{ display:inline-flex; align-items:center; }
.ibf-icons{ display:flex; gap:4px; }
.ibf-icon{
    width:28px; height:28px; border-radius:50%; background:#fff; color:#2f3f4c;
    display:inline-flex; align-items:center; justify-content:center; text-decoration:none;
    transition: transform .15s ease; font-size:14px; line-height:1;
}
.ibf-icon:hover{ transform: translateY(-1px); }

/* === Bas de page === */
.ibf-bottom{
    border-top:1px solid rgba(255,255,255,.08);
    text-align:center; padding-top:16px; margin-top:28px;
    font-size:13px; color:#cfd8de;
}
.ibf-bottom a{ color:#e7eef3; text-decoration:underline; }
.ibf-bottom a:hover{ color: var(--ib-gold, #dec38f); }
.ibf-legal{ margin-top:6px; }

/* === Responsive === */
@media (max-width:1024px){
    .ibf-grid{ gap:20px; }
    .ibf-logo{ max-width:320px; }
}
@media (max-width:820px){
    .ibf-grid{
        grid-template-columns: 1fr;
        gap:16px;
    }
    .ibf-logo-wrap, .ibf-badge-fr, .ibf-badge-vert,
    .ibf-about, .ibf-links, .ibf-social{
        grid-column:1 !important;
    }
    .ibf-logo-wrap{ justify-content:flex-start; }
}
a.social-button svg {
    height: 1em;
    width: 1em;
    color: #ffffff;
}

a.social-button svg:hover {
    height: 1em;
    width: 1em;
    color: #DEC38F;
    transition: all .2s ease-in-out
}
.ibf-grid{
    display: grid;
    grid-template-columns: 1.4fr 0.9fr 0.7fr;
    column-gap: 40px;   /* avant: 32px -> + d’air entre les 3 colonnes */
    row-gap: 36px;      /* avant: 24px -> + d’air entre images et texte */
    align-items: start;
}

/* Titre : blanc et sur une seule ligne */
.ibf-about h3{
    color: #fff !important;   /* garantit le blanc */
    font-weight: 800;
    font-size: 20px;
    margin: 0 0 12px;
    line-height: 1.2;
    white-space: nowrap;      /* une seule ligne */
    overflow: hidden;         /* évite le débordement visuel */
    text-overflow: ellipsis;  /* coupera proprement si trop long sur petits écrans */
}

/* (optionnel) Un poil d’air sous chaque capsule pour encore plus de séparation visuelle */
.ibf-badge,
.ibf-logo-wrap{
    margin-bottom: 4px;
}

/* Mobile: autoriser le retour à la ligne si l’écran est trop étroit */
@media (max-width: 820px){
    .ibf-about h3{
        white-space: normal;   /* redevient multi-lignes en mobile */
        text-overflow: unset;
    }
}
html, body, #app {
    height: 100%;             /* occuper toute la hauteur */
    margin: 0;
    display: flex;
    flex-direction: column;
}

main {
    flex: 1;                  /* prend tout l’espace dispo */
}
footer.ib-footer {
    margin-top: auto;         /* pousse le footer en bas */
}
</style>